export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0, dataText: '{"normal":10,"error":20}',
    },
    attribute:{
        title:'主机',
        paddingTop:60,
        titleWidth:60,
        titleLeft:44,
        totalTop:16,
        iconTop: 5,
        iconBottom: 10,
        iconHeight: 100,
        iconWidth: 100,
        numSize:16,
        bgUrl:null,
        progressShow:true,
        totalText:'总数',
        normalText:'正常',
        errorText:'异常',
        errorShow:true,
        cptTableData:[
            {"name":"正常指标","value":"","namekey":"normal"},
            {"name":"错误指标","value":"","namekey":"error"}
        ]
    },
}